<template>
	<div class="app-sidebar-company-settings px-5">

		<template v-if="selectedCompanyId && userHaveAccessToCompany">
			<p class="ao-p2-medium ao-text-secondary-color my-3 px-2">{{ $t('Company settings') }}</p>
			<div
				v-for="link in COMPANY_SETTINGS_PAGES"
				:key="`category-link-${link.name}`"
				class="category-link"
			>
				<SidebarLink
					:to="{
						name: link.meta.defaultChild || link.name,
						params: { companyId: selectedCompanyId },
					}"
					:title="link.meta.titleTranslationKey ? $t(link.meta.titleTranslationKey) : link.meta.title"
					:active="route.name === link.name"
				/>
			</div>

			<div class="py-3"/>

			<p class="ao-p2-medium ao-text-secondary-color my-3 px-2">{{ $t('Personal settings') }}</p>
			<div
				v-for="link in COMPANY_PERSONAL_SETTINGS_PAGES"
				:key="`category-link-${link.name}`"
				class="category-link"
			>
				<SidebarLink
					:to="{
						name: link.meta.defaultChild || link.name,
						params: { companyId: selectedCompanyId },
					}"
					:title="link.meta.titleTranslationKey ? $t(link.meta.titleTranslationKey) : link.meta.title"
					:active="route.name === link.name"
				/>
			</div>

			<template v-if="telegramBotLink">
				<div class="py-3"/>

				<ao-btn
					prependIconName="telegram"
					block
					size="x-large"
					variant="outlined"
					:href="telegramBotLink"
				>
					Telegram
				</ao-btn>
			</template>
		</template>

	</div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import useRouts from '@/composables/useRouts'

import { useUserStore } from '@/stores/userStore'

import SidebarLink from './SidebarLink.vue'

import { COMPANY_SETTINGS_PAGES, COMPANY_PERSONAL_SETTINGS_PAGES } from '@/config/router/companySettingsPagesConfig'

const {
	route,
} = useRouts()

const userStore = useUserStore()
const {
	selectedCompanyId,
	userHaveAccessToCompany,
} = storeToRefs(userStore)

const telegramBotLink = computed(() => {
	return import.meta.env.VITE_APP_LINK_TO_TELEGRAM_BOT
})
</script>

<style lang="scss">

</style>
